import ActionType from 'actions/ActionType'

const initialState = () => ({
  entity: null,
  subentity: null,
  subentity_value: null,
  operator: '==',
  subcriteria: [],
  isCustomField: false,
  customFieldName: '',
})

export default (state = initialState(), action) => {
  const switchObj = {
    [ActionType.Campaign.SELECT_EVENT_GOAL]: () => {
      if (action?.payload?.type === 'customform') {
        return {
          ...state,
          entity: action?.payload?.id,
          subentity: null,
          subentity_value: null,
          operator: '==',
          subcriteria: [],
        }
      }
      return state
    },
    [ActionType.Campaign.CHANGE_SUBENTITY]: () => {
      return {
        ...state,
        subentity:
          typeof action.subIdx === 'number' ? state.subentity : action.payload,
        subcriteria:
          typeof action.subIdx === 'number'
            ? state.subcriteria.map((subcriteria, idx) => {
                if (idx === action.subIdx) {
                  return {
                    ...state.subcriteria?.[action.subIdx],
                    subentity: action.payload,
                  }
                }
                return subcriteria
              })
            : state.subcriteria,
        operator:
          action.customFormQuestion?.field?.type ===
          'number'
            ? 'eq'
            : state.operator,
      }
    },
    [ActionType.Campaign.CHANGE_SUBENTITY_VALUE]: () => {
      if (typeof action.subIdx === 'number') {
        return {
          ...state,
          subcriteria: state.subcriteria.map((subcriteria, idx) => {
            if (idx === action.subIdx) {
              return {
                ...state.subcriteria?.[action.subIdx],
                subentity_value: action.payload,
              }
            }
            return subcriteria
          }),
        }
      }

      return {
        ...state,
        subentity_value: action.payload,
      }
    },
    [ActionType.Campaign.CHANGE_OPERATOR]: () => {
      if (typeof action.subIdx === 'number') {
        return {
          ...state,
          subcriteria: state.subcriteria.map((subcriteria, idx) => {
            if (idx === action.subIdx) {
              return {
                ...state.subcriteria?.[action.subIdx],
                operator: action.payload,
              }
            }
            return subcriteria
          }),
        }
      }

      return {
        ...state,
        operator: action.payload,
      }
    },
    [ActionType.Campaign.CHANGE_ENTITY]: () => {
      return {
        ...state,
        entity: action.payload,
        subentity: null,
        subentity_value: null,
        operator: '==',
        subcriteria: [],
      }
    },
    [ActionType.Campaign.RECEIVE_CAMPAIGN]: () => {
      return initialState()
    },
    [ActionType.Campaign.ADD_OR_EDIT_EVENT_GOAL]: () => {
      // this is what needs to change:
      const newState = initialState()
      if (action.payload?.event_goal) {
        const event_goal = action.payload.event_goal
        const properties = [
          'entity',
          'subentity',
          'subentity_value',
          'operator',
        ]

        for (let i = 0; i < properties.length; i++) {
          const property = properties[i]

          if (event_goal?.[property]) {
            newState[property] = event_goal?.[property]
          }
        }

        if (event_goal?.and_subcriteria?.length > 1) {
          newState.subcriteria = event_goal?.and_subcriteria
            ?.slice?.(1)
            ?.map(subCrt => {
              const returnObj = {}
              if (subCrt.subentity) returnObj.subentity = subCrt.subentity
              if (subCrt.subentity_value)
                returnObj.subentity_value = subCrt.subentity_value
              if (subCrt.operator) returnObj.operator = subCrt.operator
              return returnObj
            })
        }
      }

      return newState
    },
    [ActionType.Campaign.ADD_SUBCRITERIA]: () => {
      return {
        ...state,
        subcriteria: [
          ...state.subcriteria,
          { subentity: null, subentity_value: null },
        ],
      }
    },
    [ActionType.Campaign.REMOVE_SUBCRITERIA]: () => {
      return {
        ...state,
        subcriteria: state.subcriteria
          .slice(0, action.payload)
          .concat(state.subcriteria.slice(action.payload + 1)),
      }
    },
    [ActionType.Campaign.REMOVE_NEW_EVENT_GOAL]: () => {
      return initialState()
    },
    [ActionType.Campaign.ADD_EVENT_GOAL_TO_CAMPAIGN]: () => {
      return initialState()
    },
    [ActionType.Campaign.CHANGE_CUSTOM_FIELD]: () => {
      if (typeof action.subIdx === 'number') {
        return {
          ...state,
          subcriteria: state.subcriteria.map((subcriteria, idx) => {
            if (idx === action.subIdx) {
              return {
                ...state.subcriteria?.[action.subIdx],
                isCustomField: action.payload.isCustomField,
                customFieldName: action.payload.customFieldName,
                subentity: action.payload.customFieldName || null,
              }
            }
            return subcriteria
          }),
        }
      }

      return {
        ...state,
        isCustomField: action.payload.isCustomField,
        customFieldName: action.payload.customFieldName,
        subentity: action.payload.customFieldName || null,
      }
    },
  }

  return switchObj?.[action?.type] ? switchObj[action?.type]() : state
}
